export const state = {
	articles: [],
	tags: [],
	userTags: [],
	banques: [],
	myNews: []
}



// WEBPACK FOOTER //
// ./src/common/store/News/state.js